<div class="modal fade" id="cancelAllUploadsModal" tabindex="-1" aria-labelledby="cancelAllUploadsModal" aria-hidden="true" [ngStyle]="{'display': showCancelAllUploads ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-md">
        <div class="modal-content">
            <div class="modal-header">
                <h5>Cancel all Upload(s)?</h5>
                <button type="button" data-dismiss="modal" class="close btn-pos d-none d-md-block" (click)="cancelUploads(false)"><span class="NeueFile_Cancel"></span><span class="esc">esc</span></button>
            </div>
            <div class="modal-body pt-4">
                <div class="cancel-upload-details">
                    <p>Your uploads are not complete!!</p>
                    <p>Would you still like to cancel all ongoing operations ?</p>
                </div>
            </div>
            <div class="modal-footer pt-0">
                <!-- Button -->
                <div class="btn-wrap">
                    <button class="btn btn-cancel mb-3 mb-md-0" title="Cancel all uploads" id="btn-cancel" (click)="cancelUploads(true)">Cancel Upload</button>
                    <button class="btn btn-continue" id="btn-continue" title="Continue upload" data-dismiss="modal" (click)="cancelUploads(false)">Continue Upload</button>
                </div>
            </div>
        </div>
    </div>
</div>